import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

export interface ToastConfig {
  message: string;
  type: 'success' | 'info' | 'error';
  duration?: number;
}

@Component({
  selector: 'app-toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.css']
})
export class ToastNotificationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() message: string = '';
  @Input() type: 'success' | 'info' | 'error' = 'info';
  @Input() duration: number | null = null;
  @Input() show: boolean = false;
  @Input() action?: { label: string; callback: () => void };
  @Input() dismissable: boolean = true;

  @Output() onClose = new EventEmitter<void>();
  @ViewChild('progressBar', { static: false }) progressBar?: ElementRef;

  private timeoutId?: number;
  isVisible = false;
  isAnimatingOut = false;

  ngOnInit() {
    if (this.show) {
      this.showToast();
    }
  }

  ngAfterViewInit() {
    if (this.progressBar) {
      this.progressBar.nativeElement.style.setProperty('--duration', `${this.duration}ms`);
    }
  }

  ngOnDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  showToast() {
    this.isVisible = true;
    this.isAnimatingOut = false;

    if (this.progressBar && this.duration !== null) {
      this.progressBar.nativeElement.style.setProperty('--duration', `${this.duration}ms`);
    }

    if (this.duration !== null) {
      this.timeoutId = window.setTimeout(() => {
        this.hideToast();
      }, this.duration);
    }
  }

  hideToast() {
    this.isAnimatingOut = true;

    setTimeout(() => {
      this.isVisible = false;
      this.isAnimatingOut = false;
      this.onClose.emit();
    }, 300);
  }

  onToastClick() {
    // manual dismissal
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.hideToast();
  }

  getToastIcon(): string {
    switch (this.type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'info':
      default:
        return 'info';
    }
  }

  onActionClick(event: Event) {
    event.stopPropagation();
    if (this.action && this.action.callback) {
      this.action.callback();
    }
  }
}
